module.exports = "/_next/static/images/accion-1ef32a76a8313523e2391d9caada97e7.png";